<template>
  <tbody>
    <tr class="is-border-top">
      <td class="has-text-centered">
        <span class="avatar avatar-01">
          <span class="has-bg-draft"><i class="fas" :class="firstKey === 'company' ? 'fa-building' : 'fa-city'"></i></span>
        </span>
      </td>
      <td>
        <router-link :to="{name: 'CompanyVue', params: {id: a.company}}" v-if="firstKey === 'company'">{{a.company_name | truncate}}</router-link>
        <router-link :to="{name: 'ProgramVue', params: {id: a.program}}" v-else>{{a.program_name | truncate}}</router-link>
      </td>
      <td>{{a.start_date}}</td>
      <td>{{a.end_date}}</td>
      <td class="is-narrow"><span v-if="a.allotment_count" class="tag is-allotement is-uppercase">{{a.allotment_count}} {{'Lot' | pluralize(a.allotment_count > 1)}} {{'Alloté' | pluralize(a.allotment_count > 1)}}</span></td>
      <td v-if="displayRemuneration" class="is-paddingless is-marginless" style="width: 250px;">
        <div class="field has-addons is-border-left">
          <div class="control has-incrementations">
            <input type="number"
                   class="input is-borderless is-medium has-text-centered"
                   max="100"
                   placeholder="A définir"
                   :disabled="editAccess"
                   @focus="selectInput('inputrem')" ref="inputrem"
                   @input="selectEditedRem"
                   v-model="a.remuneration">
            <div class="incrementation" v-if="isAdmin">
              <a class="incrementation-btn" @click="selectEditedRem(); a.remuneration++"><i class="fas fa-chevron-up"></i></a>
              <a class="incrementation-btn" @click="selectEditedRem(); a.remuneration--"><i class="fas fa-chevron-down"></i></a>
            </div>
          </div>
          <div class="control">
            <a class="button is-square is-medium is-light is-min-width-0 is-static">
              <span class="icon is-size-5"><i class="fas fa-percentage"></i></span>
            </a>
          </div>
          <div class="dropdown is-hoverable is-right" v-if="!editRem && !editAccess && !loading && isAdmin">
            <div class="dropdown-trigger">
              <button class="button is-square is-medium is-min-width-0 is-radiusless is-borderless" aria-haspopup="true" aria-controls="dropdown-menu">
                <i class="fal fa-ellipsis-v"></i>
              </button>
            </div>
            <div class="dropdown-menu" role="menu">
              <div class="dropdown-content has-text-left">
                <a class="dropdown-item" @click="selectEditedAccess">
                  <span class="icon is-size-5"><i class="fal fa-edit"></i></span>
                  Modifier mandat
                </a>
                <a class="dropdown-item has-text-danger" @click="deleteAccess">
                  <span class="icon is-size-5"><i class="fas fa-trash"></i></span>
                  Supprimer mandat
                </a>
              </div>
            </div>
          </div>
          <div class="control" v-if="editRem && !loading">
            <a class="button is-square is-medium is-success is-min-width-0 has-hover-black" @click="updateAccess">
              <span class="icon is-size-5"><i class="fas fa-save"></i></span>
            </a>
          </div>
          <div class="control" v-if="(editRem || editAccess) && !loading">
            <a class="button is-square is-medium is-draft is-min-width-0" @click="cancelEditAccess">
              <span class="icon is-size-5 has-text-white"><i class="fas fa-times"></i></span>
            </a>
          </div>
          <div class="control" v-if="loading">
            <button class="button is-square is-medium is-primary is-min-width-0 has-hover-black is-loading">
              <span class="icon"><i class="fas fa-lg fa-spinner-third"></i></span>
            </button>
          </div>
        </div>
      </td>
    </tr>
    <tr v-if="editAccess">
      <td colspan="7" class="box3 is-paddingless">
        <access-form ref="accessForm"
                     :createMode="false"
                     @submit="updateAccess"
                     :source="a"
                     :source-program="program"
                     :source-lots="lots"
                     :source-promoteur="promoteur"
                     :source-company="company"
                     @canUpdateAccess="val => canUpdateAccess = val">
        </access-form>
        <div class="column is-12 is-paddingless columns">
          <div class="column is-6">
            <a @click="editAccess = false" class="button is-white is-uppercase is-fullwidth">
              <span>Annuler</span>
            </a>
          </div>
          <div class="column is-6">
            <button @click="askSubmit" class="button is-success is-uppercase is-fullwidth has-text-white"
                    :disabled=" !canUpdateAccess || loading" :class="{'is-loading':loading}">
              <span v-if="!loading">Valider</span>
            </button>
          </div>
        </div>
      </td>
    </tr>
    <slot></slot>
  </tbody>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { cloneDeep, debounce } from 'lodash'
  import AccessForm from '@/components/access/AccessForm'

  export default {
    name: 'ProgramAccessItem',
    components: {AccessForm},
    data () {
      return {
        a: null,
        savedAccess: null,
        editAccess: false,
        editRem: false,
        canUpdateAccess: true
      }
    },
    props: {
      source: Object,
      program: [Object, String],
      lots: Array,
      promoteur: [Object, String],
      company: [Object, String],
      loadingAccess: Boolean,
      selectedAccess: String,
      firstKey: {
        type: String,
        default: 'name'
      }
    },
    watch: {
      source (v) {
        this.a = v
        this.savedAccess = cloneDeep(v)
        this.editAccess = false
        this.editRem = false
      },
      selectedAccess (v) {
        if (v !== this.a.pk) {
          this.cancelEditAccess()
        }
      }
    },
    computed: {
      ...mapGetters(['displayRemuneration', 'isAdmin']),
      loading () {
        return this.loadingAccess && this.selectedAccess === this.a.pk
      }
    },
    methods: {
      selectEditedAccess () {
        this.editAccess = true
        this.$emit('selectedAccess', this.a.pk)
      },
      selectEditedRem: debounce(function () {
        this.editRem = true
        this.$emit('selectedAccess', this.a.pk)
      }, 400),
      updateAccess (a) {
        this.a = Object.assign(this.a, a)
        this.editAccess = false
        this.editRem = false
        this.$emit('updateAccess', this.a)
      },
      cancelEditAccess () {
        this.editAccess = false
        this.editRem = false
        this.a = cloneDeep(this.savedAccess)
      },
      deleteAccess () {
        this.$emit('deleteAccess', this.a.pk)
      },
      askSubmit () {
        this.$refs.accessForm.submit()
      },
      selectInput (input) {
        if (input in this.$refs) {
          if (Array.isArray(this.$refs[input])) {
            this.$refs[input][0].select()
          } else {
            this.$refs[input].select()
          }
        }
      }
    },
    created () {
      if (this.source) {
        this.editAccess = false
        this.editRem = false
        this.a = this.source
        this.savedAccess = cloneDeep(this.source)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/program/Tabs/ProgramAccessItem.vue